
import { defineComponent, PropType } from 'vue';
import getAirport from '@white-label-helper/mixin-get-airport';
// Types
import type { CartItem, Item } from '@white-label-types/parking-checkout';
import useDepositStore from "@white-label-store/deposits";

type SummaryElement = CartItem | Item;

export default defineComponent({
  name: 'SummaryAirport',
  mixins: [getAirport],
  props: {
    product: {
      type: Object as PropType<SummaryElement>,
      required: true,
    },
    isRefund: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasDeposit(): false | { payNow: string, payOnArrival: string } {
      const depositOnly = useDepositStore();
      if (depositOnly.cartTotalDepositAmount === null) {
        return false;
      }

      return depositOnly.cartTotalDepositAmount;
    },
    airportLabel(): string {
      let airportLabel = `${this.airport.name} (${this.airport.code})`;
      if (this.hasDeposit && !this.isRefund) {
         airportLabel += ` ${this.$t('shared.payOnArrival')}`;
      }
      return airportLabel;
    }
  }
});
